module.exports = ".fa-heart {\r\n    color: #dc0000;\r\n    -webkit-transition: all ease-out 0.3s;\r\n    transition: all ease-out 0.3s;\r\n    text-shadow: 1px 2px 3px #840000;\r\n}\r\n\r\n.heartIcon {\r\n}\r\n\r\n.heartIcon.disabled-icon {\r\n}\r\n\r\n.fa-heart-o.disabled-icon {\r\n    display: none;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/base-reaction/base-reaction.component.css
// module id = ./src/app/commons/base-reaction/base-reaction.component.css
// module chunks = main